import { createSlice } from "@reduxjs/toolkit";

import {
  verifyIfscAction,
  getBankAccountInfoAction,
  getGstInfoAction,
  verifyPanAction,
  panAadharLinkStatusAction,
  verifyTanAction,
  verifyShippingAddressPanAction,
  authorizedVerifyPanAction,
} from "@/redux/services/actions";
import { initialState } from "@/redux/services/initialState";
import { servicesReducer } from "@/redux/services/reducer";
import type { ServicesTypes } from "@/redux/services/serviceTypes";

export const servicesSlice = createSlice({
  name: "services",
  initialState,
  reducers: servicesReducer,

  extraReducers: (builder) => {
    builder.addCase(getGstInfoAction.pending, (state: ServicesTypes) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      getGstInfoAction.fulfilled,
      (state: ServicesTypes, { payload }) => {
        const { success, data, message } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            gstDetails: null,
            success: 0,
          };
        }

        return {
          ...state,
          fetching: false,
          gstDetails: data,
          error: null,
          success,
        };
      }
    );

    builder.addCase(
      getGstInfoAction.rejected,
      (state: ServicesTypes, { error }) => ({
        ...state,
        error: error.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(verifyIfscAction.pending, (state: ServicesTypes) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      verifyIfscAction.fulfilled,
      (state: ServicesTypes, { payload }) => {
        const { success, data, message } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            ifscDetails: null,
          };
        }

        return {
          ...state,
          fetching: false,
          ifscDetails: data,
          error: null,
        };
      }
    );

    builder.addCase(
      verifyIfscAction.rejected,
      (state: ServicesTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      getBankAccountInfoAction.pending,
      (state: ServicesTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getBankAccountInfoAction.fulfilled,
      (state: ServicesTypes, { payload }) => {
        const { success, result, message } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            bankAccountDetails: {},
          };
        }

        return {
          ...state,
          fetching: false,
          error: null,
          bankAccountDetails: {
            account_exists:
              result?.data?.account_exists === true
                ? "Yes"
                : result?.data?.account_exist === false
                  ? "No"
                  : "",
            amount_deposited: "0",
            message: result?.data?.account_exists
              ? result?.data?.message === "Given account is an NRE account" ||
                result?.data?.message === "Account is blocked"
                ? result?.data?.message
                : result?.data?.account_exists && !result?.data?.message
                  ? "Bank Details is Verified"
                  : result?.data?.account_exists &&
                      result?.data?.message ===
                        "Bank Account details verified successfully."
                    ? "Bank Details is Verified"
                    : result?.data?.message
              : result?.data?.message,
            name_at_bank: result?.data?.name_at_bank,
          },
        };
      }
    );

    builder.addCase(
      getBankAccountInfoAction.rejected,
      (state: ServicesTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      panAadharLinkStatusAction.pending,
      (state: ServicesTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      panAadharLinkStatusAction.fulfilled,
      (state: ServicesTypes, { payload }) => {
        const { success, message, data } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          panAadharLinkStatus: data,
        };
      }
    );

    builder.addCase(
      panAadharLinkStatusAction.rejected,
      (state: ServicesTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error.message ?? null,
      })
    );

    builder.addCase(verifyPanAction.pending, (state: ServicesTypes) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      verifyPanAction.fulfilled,
      (state: ServicesTypes, { payload }) => {
        const { success, data, message } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          panVerifyDetails: data,
        };
      }
    );

    builder.addCase(
      verifyPanAction.rejected,
      (state: ServicesTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      authorizedVerifyPanAction.pending,
      (state: ServicesTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      authorizedVerifyPanAction.fulfilled,
      (state: ServicesTypes, { payload }) => {
        const { success, data, message } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          authorizedPanVerifyDetails: data,
        };
      }
    );

    builder.addCase(
      authorizedVerifyPanAction.rejected,
      (state: ServicesTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      verifyShippingAddressPanAction.pending,
      (state: ServicesTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      verifyShippingAddressPanAction.fulfilled,
      (state: ServicesTypes, { payload }) => {
        const { success, data, message } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          shippingAddressPanVerifyDetails: data,
        };
      }
    );

    builder.addCase(
      verifyShippingAddressPanAction.rejected,
      (state: ServicesTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error.message ?? null,
      })
    );

    builder.addCase(verifyTanAction.pending, (state: ServicesTypes) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      verifyTanAction.fulfilled,
      (state: ServicesTypes, { payload }) => {
        const { success, data, message } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          tanVerifyDetails: data,
        };
      }
    );

    builder.addCase(
      verifyTanAction.rejected,
      (state: ServicesTypes, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );
  },
});

export const {
  resetError: resetServicesError,
  resetSuccess: resetServicesSucces,
  resetIfscData,
  resetBankAccountDetails,
  resetGstDetails,
  resetPanVerifyData,
  resetTanVerifyData,
  resetPanAadharLinkStatus,
  resetServicesFetching,
  resetShippingAddressPanVerifyDetails,
  resetAuthorizedPanVerifyData,
} = servicesSlice.actions;
